export class PatientEdiaryEntry {
  public id: string;
  public date: Date;
  public submittedDate: Date;
  public updatedBy: string;
  public timezone: string;
  public reminderTimeMinutes: number;
  public reminderTimeMinutesUtc: number;
  public remindersEnabled: boolean;
  public reminderNotificationDateTimeUtc: Date;
  public reminderNotificationSentDateTimeUtc: Date;
  public emailSiteRuleMatched: boolean;
  public emailSentToSite: boolean;

  constructor(init?: Partial<PatientEdiaryEntry>) {
    Object.assign(this, init);
  }
}
